export default "__VITE_ASSET__c40966f7__"